/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchAccount} from '../api'

export const useMutationSearchAccount = createReactQueryMutationHook('searchAccount', searchAccount)
